import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const DropdownWrapper = styled.div`
    display: flex;
`;

export const DropdownContainer = styled.div`
    margin-bottom: 25px;
    width: 400px;
`;

export const SegmentsTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    max-width: 400px;
    justify-content: space-between;
`;

export const SelectedSegmentsCount = styled.span<{ isMaxReached: boolean }>`
    ${setFontVariant("subsectionTitle")}
    margin: 10px 0 20px 0;
    ${({ isMaxReached }) =>
        isMaxReached ? `color: ${colorsPalettes.red[400]}` : `color: ${colorsPalettes.carbon[400]}`}
`;
